import { Notification } from 'element-ui'
import axios from 'axios'

function notificationError (error) {
  // 401 会有页内登录
  if (error.response.status !== 401) {
    if (error.response) {
      const message = _.get(error, 'response.data.message', '')
      if (error.response.status === 403) {
        Notification.warning({
          title: '警告',
          dangerouslyUseHTMLString: true,
          message: `<div>此操作无权限。</div><div>${message}</div>`,
          offset: 50,
        })
      } else if (error.response.status === 422) {
        const data = error.response.data
        let messageList = message
        for (const key in data.errors) {
          data.errors[key].forEach((message) => {
            messageList += `<div>${message}</div>`
          })
        }
        Notification.warning({
          title: '参数不正确',
          dangerouslyUseHTMLString: true,
          message: messageList,
          offset: 50,
        })
      } else if (error.response.status === 423) {
        Notification.warning({
          title: '资源被锁定',
          dangerouslyUseHTMLString: true,
          message,
          offset: 50,
        })
      } else if (error.response.status >= 400) {
        Notification.error({
          title: '请求错误',
          message,
          offset: 50,
        })
      } else if (error.response.status >= 500) {
        Notification.error({
          title: '服务器错误',
          message,
          offset: 50,
        })
      }
    } else {
      Notification.error({
        title: '未知错误',
        message: error.toString(),
        offset: 50,
      })
    }
  }
}

function showAlert (promise) {
  return promise.catch((error) => {
    notificationError(error)
    // 返回响应错误
    return Promise.reject(error)
  })
}

function handleData (promise) {
  return promise.then((response) => {
    return response
  }).catch((error) => {
    // 强制打印一份错误
    console.warn(error)
    // 重新登录
    if (!promise.disableAuth && error.response && error.response.status === 401) {
      store.commit('layout/OPEN_LOGIN_DIALOG')
    }
    return Promise.reject(error)
  })
}

function exceptionResponse (error) {
  if (Object.prototype.hasOwnProperty.call(error, 'response')) {
    const response = error.response
    if (response.status !== 401) {
      if (response.status === 403) {
        router.exception.throw(response.status, '哎呀...没有权限访问该页面！')
      } else if (response.status === 404) {
        router.exception.throw(response.status, '哎呀...找不到页面了！')
      } else if (response.status >= 500) {
        router.exception.throw(response.status, '服务器错误')
      } else {
        router.exception.throw(response.status, '请求错误')
      }
    }
  } else if (axios.Cancel === error.constructor) {
    console.warn('切换页面，取消请求……')
  } else {
    router.exception.throw(error.message, '未知错误')
  }
}

function showLoading (promise) {
  store.commit('layout/OPEN_LOADING')
  return promise.finally(() => {
    store.commit('layout/CLOSE_LOADING', 1)
  })
}

function jwtRequest (name, ...args) {
  return handleData(jwtRequest.dispatch(name, ...args))
}

function getRequestItems () {
  const items = {}
  const modules = requires(require.context('@/apis', true, /\.api\.js$/), false)
  // 模块列表
  for (const path in modules) {
    if (Object.prototype.hasOwnProperty.call(modules, path)) {
      // 请求列表
      for (const name in modules[path]) {
        if (Object.prototype.hasOwnProperty.call(modules[path], name)) {
          // api 是否已存在
          if (Object.prototype.hasOwnProperty.call(items, name)) {
            console.error(`${items[name].path} 和 ${path} 中的 ${name} 方法冲突。`)
          } else {
            items[name] = modules[path][name]
            items[name].path = path
          }
        }
      }
    }
  }
  return items
}

jwtRequest.items = getRequestItems()

jwtRequest.dispatch = (name, ...args) => {
  return jwtRequest.items[name](...args)
}

jwtRequest.alert = (name, ...args) => {
  return showAlert(jwtRequest(name, ...args))
}

jwtRequest.loading = (name, ...args) => {
  return showLoading(jwtRequest(name, ...args))
}

jwtRequest.common = (name, ...args) => {
  return showLoading(showAlert(jwtRequest(name, ...args)))
}

jwtRequest.all = (items) => {
  return Promise.all(items)
}

jwtRequest.all.common = (items) => {
  return showLoading(showAlert(Promise.all(items)))
}

jwtRequest.all.loading = (items) => {
  return showLoading(Promise.all(items))
}

jwtRequest.all.alert = (items) => {
  return showAlert(Promise.all(items))
}

jwtRequest.page = (name, ...args) => {
  return showLoading(jwtRequest(name, ...args).catch((error) => {
    // 异常响应
    exceptionResponse(error)
    // 抛出异常
    return Promise.reject(error)
  }))
}

jwtRequest.all.page = (items) => {
  return showLoading(Promise.all(items).catch((error) => {
    // 异常响应
    exceptionResponse(error)
    // 抛出异常
    return Promise.reject(error)
  }))
}

jwtRequest.map = (items) => {
  const requests = {}
  items.forEach((name) => {
    requests[name] = function (...args) {
      return jwtRequest(name, ...args)
    }
  })
  return requests
}

jwtRequest.notificationError = notificationError

export default jwtRequest
